export default {
  API_ENDPOINT: 'https://protected-shore-69640.herokuapp.com/api',
  TOKEN_KEY: 'blogful-client-auth-token',
};
